/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spell_Numbers_DescInputs */



/**
* | output |
* | --- |
* | "Convert numbers to words" |
*
* @param {Spell_Numbers_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const spell_numbers_desc = /** @type {((inputs?: Spell_Numbers_DescInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spell_Numbers_DescInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Convertir les chiffres en mots")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zahlen in Wörter umwandeln")
	if (locale === "it") return /** @type {LocalizedString} */ ("Convertire i numeri in parole")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Преобразуйте числа в слова.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Convertir números en palabras")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("将数字转换为文字")
	if (locale === "ja") return /** @type {LocalizedString} */ ("数字を単語に変換する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("संख्याओं को शब्दों में बदलें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Converter números em palavras")
	return /** @type {LocalizedString} */ ("Convert numbers to words")
});